/**
 * Returns true when device is iOS.
 * https://stackoverflow.com/a/9039885/14463679
 */
export var isIOS = function isIOS() {
  var _navigator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator;
  var _ontouchend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ontouchend' in document;
  return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(_navigator.platform) ||
  // iPad on iOS 13 detection
  _navigator.userAgent.includes('Mac') && _ontouchend;
};
//# sourceMappingURL=user-agent.js.map